import React from 'react';
import { motion } from 'framer-motion';
interface EbookMockupProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function EbookMockup({
  size = 'md',
  className = ''
}: EbookMockupProps) {
  const sizeClasses = {
    sm: 'w-32 h-44',
    md: 'w-48 h-64',
    lg: 'w-64 h-80 md:w-80 md:h-[420px]'
  };
  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-lg md:text-xl'
  };
  return <motion.div className={`relative perspective-1000 ${className}`} initial={{
    opacity: 0,
    y: 20,
    rotateY: -10
  }} whileInView={{
    opacity: 1,
    y: 0,
    rotateY: -15
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} style={{
    perspective: '1000px'
  }} data-id="element-27">
      {/* Book Container */}
      <div className={`relative preserve-3d shadow-2xl ${sizeClasses[size]}`} style={{
      transformStyle: 'preserve-3d',
      transform: 'rotateY(-15deg) rotateX(5deg)'
    }} data-id="element-28">
        {/* Book Cover */}
        <div className="absolute inset-0 rounded-r-md rounded-l-sm overflow-hidden border border-white/20 shadow-inner z-10" data-id="element-29">
          <img src="https://cdn.magicpatterns.com/uploads/ddfhVqrmmHaf8FXnjDwX92/Portada_libro.png" alt="14 Días Para Desinflamar Tu Cuerpo - Guía Práctica" className="w-full h-full object-cover object-center" data-id="element-30" />
          {/* Cover Highlight/Gloss */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/8 to-white/0 transform -skew-x-12 translate-x-full group-hover:translate-x-[-200%] transition-transform duration-1000" data-id="element-31"></div>
        </div>

        {/* Book Spine */}
        <div className="absolute top-0 bottom-0 left-0 w-6 bg-olive rounded-l-sm border-l border-white/10" style={{
        transform: 'rotateY(-90deg) translateZ(3px) translateX(3px)',
        transformOrigin: 'left'
      }} data-id="element-32"></div>

        {/* Book Pages (Right Edge) */}
        <div className="absolute top-[2%] bottom-[2%] right-0 w-4 bg-cream border-r border-gray-200 rounded-r-sm" style={{
        transform: 'rotateY(90deg) translateZ(1px)',
        transformOrigin: 'right',
        backgroundImage: 'repeating-linear-gradient(to bottom, transparent, transparent 2px, rgba(0,0,0,0.05) 2px, rgba(0,0,0,0.05) 3px)'
      }} data-id="element-33"></div>
      </div>

      {/* Floor Shadow */}
      <div className="absolute -bottom-4 left-4 right-4 h-8 bg-black/20 blur-xl rounded-full transform rotate-x-60" data-id="element-34"></div>
    </motion.div>;
}